var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _path21, _path22, _path23, _path24, _rect2, _span, _text, _span2, _text2, _path25, _path26, _path27, _path28, _rect3, _path29, _path30, _path31, _path32, _path33, _path34, _rect4, _rect5, _span3, _text3, _path35, _path36, _path37, _path38, _path39, _path40, _rect6, _text4, _rect7, _text5, _rect8, _text6, _rect9, _text7, _rect10, _text8, _rect11, _br, _br2, _br3, _text9, _path41, _path42, _path43, _path44, _rect12, _text10, _path45, _path46, _rect13, _text11, _rect14, _text12, _rect15, _text13, _rect16, _text14, _rect17, _br4, _br5, _text15, _rect18, _br6, _text16, _rect19, _br7, _br8, _text17, _rect20, _path47, _path48, _span4, _text18, _text19, _path49, _path50, _br9, _text20, _rect21, _path51, _path52, _span5, _text21, _rect22, _br10, _br11, _text22, _path53, _path54, _rect23, _rect24, _path55, _path56, _span6, _text23, _text24, _rect25, _br12, _text25, _rect26, _br13, _text26, _text27, _rect27, _br14, _text28, _rect28, _path57, _path58, _text29, _rect29, _br15, _text30, _rect30, _br16, _text31, _rect31, _text32, _rect32, _br17, _text33, _rect33, _br18, _br19, _br20, _text34, _text35, _rect34, _br21, _text36, _rect35, _text37, _path59, _path60, _path61, _path62, _rect36, _path63, _path64, _rect37, _path65, _path66, _rect38, _text38, _text39, _text40, _path67, _path68;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefinery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "953px",
    height: "651px",
    viewBox: "-0.5 -0.5 953 651",
    content: "<mxfile modified=\"2019-02-16T16:48:04.129Z\" host=\"www.draw.io\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/72.0.3626.109 Safari/537.36\" etag=\"i7gMLXV7BYq2ZO2EEMlj\" version=\"10.2.3\" type=\"device\"><diagram id=\"_4kYuwqSJ0uvlSOtblJf\" name=\"Page-1\">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</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 242 270 L 242 370 L 295.63 370",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 300.88 370 L 293.88 373.5 L 295.63 370 L 293.88 366.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 267 250 L 377 250 L 377 300 L 490.63 300",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 495.88 300 L 488.88 303.5 L 490.63 300 L 488.88 296.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 267 228.5 L 340.63 228.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 345.88 228.5 L 338.88 232 L 340.63 228.5 L 338.88 225 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 217 87 C 217 78.72 228.19 72 242 72 C 255.81 72 267 78.72 267 87 L 267 254 C 267 262.28 255.81 269 242 269 C 228.19 269 217 262.28 217 254 Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 217 100.5 L 267 100.5 M 217 110.5 L 267 110.5 M 217 120.5 L 267 120.5 M 217 130.5 L 267 130.5 M 217 140.5 L 267 140.5 M 217 150.5 L 267 150.5 M 217 160.5 L 267 160.5 M 217 170.5 L 267 170.5 M 217 180.5 L 267 180.5 M 217 190.5 L 267 190.5 M 217 200.5 L 267 200.5 M 217 210.5 L 267 210.5 M 217 220.5 L 267 220.5 M 217 230.5 L 267 230.5 M 217 240.5 L 267 240.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 352 329 L 352 316 L 490.63 316",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 495.88 316 L 488.88 319.5 L 490.63 316 L 488.88 312.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 327 430 L 327 570 L 379.63 570",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 384.88 570 L 377.88 573.5 L 379.63 570 L 377.88 566.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 327 480 L 460.63 480",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 465.88 480 L 458.88 483.5 L 460.63 480 L 458.88 476.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 347 420 L 437 420 L 437 200 L 470.63 200",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 475.88 200 L 468.88 203.5 L 470.63 200 L 468.88 196.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 302 325 C 302 316.72 313.19 310 327 310 C 340.81 310 352 316.72 352 325 L 352 415 C 352 423.28 340.81 430 327 430 C 313.19 430 302 423.28 302 415 Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 302 335 L 352 335 M 302 345 L 352 345 M 302 355 L 352 355 M 302 365 L 352 365 M 302 375 L 352 375 M 302 385 L 352 385 M 302 395 L 352 395 M 302 405 L 352 405",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 467 567.5 L 540.63 567.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 545.88 567.5 L 538.88 571 L 540.63 567.5 L 538.88 564 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 550,
    width: 80,
    height: 35,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 167 170.5 L 210.63 170.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 215.88 170.5 L 208.88 174 L 210.63 170.5 L 208.88 167 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 7 173 L 79.63 173",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 84.88 173 L 77.88 176.5 L 79.63 173 L 77.88 169.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 153,
    width: 80,
    height: 35,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198.5,402.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 101,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _span || (_span = /*#__PURE__*/React.createElement("span", null, "Vacuum Distillation"))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "&lt;span&gt;Vacuum Distillation&lt;/span&gt;")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.5,261.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 125,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _span2 || (_span2 = /*#__PURE__*/React.createElement("span", null, "Atmospheric Distillation"))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 63,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "&lt;span&gt;Atmospheric Distillation&lt;/span&gt;")))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 482 515 L 482 535 L 580.63 535",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 585.88 535 L 578.88 538.5 L 580.63 535 L 578.88 531.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 497 462 L 617 462 L 617 410 L 927 410 L 927 228.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 927 223.12 L 930.5 230.12 L 927 228.37 L 923.5 230.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 467,
    y: 444.5,
    width: 30,
    height: 70,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 527 322 L 507 322 L 507 330 L 660.63 330",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 665.88 330 L 658.88 333.5 L 660.63 330 L 658.88 326.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 512 219 L 512 212 L 547 212 L 547 234 L 623.63 234",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 628.88 234 L 621.88 237.5 L 623.63 234 L 621.88 230.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 512 184 L 662 184 L 662 190 L 842 190 L 842 193.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 842 198.88 L 838.5 191.88 L 842 193.63 L 845.5 191.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 166,
    width: 30,
    height: 70,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 210,
    width: 80,
    height: 35,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(498.5,508.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 79,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _span3 || (_span3 = /*#__PURE__*/React.createElement("span", null, "Delayed Coker"))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "&lt;span&gt;Delayed Coker&lt;/span&gt;")))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 267 195.5 L 340.63 195.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 345.88 195.5 L 338.88 199 L 340.63 195.5 L 338.88 192 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 268 132.5 L 341.63 132.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 346.88 132.5 L 339.88 136 L 341.63 132.5 L 339.88 129 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 268 91.5 L 341.63 91.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 346.88 91.5 L 339.88 95 L 341.63 91.5 L 339.88 88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 547,
    y: 557,
    width: 60,
    height: 20,
    fill: "#b9e0a5",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.5,559.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 40,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Asphalt"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Asphalt")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 449.5,
    width: 120,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.5,452.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 101,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Vacuum Residuum"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Vacuum Residuum")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 587,
    y: 526,
    width: 100,
    height: 20,
    fill: "#b9e0a5",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588.5,528.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 86,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Petroleum Coke"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Petroleum Coke")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 329.5,
    width: 130,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.5,332.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 114,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Atmospheric Bottoms"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 57,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Atmospheric Bottoms")))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 269,
    width: 120,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.5,271.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 104,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Atmospheric Gasoil"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Atmospheric Gasoil")))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 319.5,
    width: 60,
    height: 40,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.5,322.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 43,
    height: 40,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Light", _br || (_br = /*#__PURE__*/React.createElement("br", null)), "Vacuum", _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null)), "Gasoil", _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 26,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 512 269 L 512 250 L 547 250 L 547 236.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 547 231.12 L 550.5 238.12 L 547 236.37 L 543.5 238.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 527 287 L 527 288 L 625.63 288",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 630.88 288 L 623.88 291.5 L 625.63 288 L 623.88 284.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 497,
    y: 269,
    width: 30,
    height: 70,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(451.5,346.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 121,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Fluid Catalytic Cracker"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 61,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Fluid Catalytic Cracker")))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 497 503 L 637 503 L 637 336.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 637 331.12 L 640.5 338.12 L 637 336.37 L 633.5 338.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 319,
    width: 60,
    height: 20,
    fill: "#b9e0a5",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(668.5,321.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 41,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Fuel Oil"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 21,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Fuel Oil")))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 507,
    y: 479.5,
    width: 80,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(508.5,482.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 69,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Coker Gasoil"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Coker Gasoil")))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 150.5,
    width: 70,
    height: 20,
    fill: "#b9e0a5",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.5,153.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 51,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Crude Oil"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Crude Oil")))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 812,
    y: 200,
    width: 140,
    height: 20,
    fill: "#b9e0a5",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(813.5,202.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 125,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Gasoline Blending Pool"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 63,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Gasoline Blending Pool")))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 344.5,
    y: 179,
    width: 70,
    height: 30,
    fill: "#b9e0a5",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.5,181.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 51,
    height: 26,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Jet Fuel", _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null)), "Kerosene", _br5 || (_br5 = /*#__PURE__*/React.createElement("br", null))))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 19,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 344.5,
    y: 218,
    width: 70,
    height: 20,
    fill: "#b9e0a5",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.5,220.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 51,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Diesel Oil", _br6 || (_br6 = /*#__PURE__*/React.createElement("br", null))))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Diesel Oil&lt;br&gt;")))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 97,
    width: 60,
    height: 30,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273.5,99.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 45,
    height: 26,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Heavy", _br7 || (_br7 = /*#__PURE__*/React.createElement("br", null)), "Naphtha", _br8 || (_br8 = /*#__PURE__*/React.createElement("br", null))))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 23,
    y: 19,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 114.5,
    width: 80,
    height: 35,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 427 132 L 475.63 132",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 480.88 132 L 473.88 135.5 L 475.63 132 L 473.88 128.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(353.5,124.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 67,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _span4 || (_span4 = /*#__PURE__*/React.createElement("span", null, "Hydrotreater"))))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "&lt;span&gt;Hydrotreater&lt;/span&gt;")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.5,164.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 45,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Desalter"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 23,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Desalter")))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 712 229 L 712 231 L 872 231 L 872 226.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 872 221.12 L 875.5 228.12 L 872 226.37 L 868.5 228.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(393.5,554.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 42,
    height: 26,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Asphalt", _br9 || (_br9 = /*#__PURE__*/React.createElement("br", null)), "Blowing"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 21,
    y: 19,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 72,
    width: 80,
    height: 35,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 427 90 L 452 90 L 470.63 90",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 475.88 90 L 468.88 93.5 L 470.63 90 L 468.88 86.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(353.5,82.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 67,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _span5 || (_span5 = /*#__PURE__*/React.createElement("span", null, "Hydrotreater"))))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "&lt;span&gt;Hydrotreater&lt;/span&gt;")))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 59.5,
    width: 60,
    height: 30,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273.5,62.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 45,
    height: 26,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Light", _br10 || (_br10 = /*#__PURE__*/React.createElement("br", null)), "Naphtha", _br11 || (_br11 = /*#__PURE__*/React.createElement("br", null))))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 23,
    y: 19,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 557 90 L 908 90 L 908 193.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 908 198.88 L 904.5 191.88 L 908 193.63 L 911.5 191.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 72,
    width: 80,
    height: 35,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 114.5,
    width: 80,
    height: 35,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 563 132 L 882 132 L 882 190.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 882 195.88 L 878.5 188.88 L 882 190.63 L 885.5 188.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(488.5,119.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 50,
    height: 26,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, _span6 || (_span6 = /*#__PURE__*/React.createElement("span", null, "Catalytic", /*#__PURE__*/React.createElement("br", null), "Reformer", /*#__PURE__*/React.createElement("br", null)))))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 19,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(478.5,82.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 71,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Isomerization"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Isomerization")))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 562,
    y: 69.5,
    width: 70,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(563.5,72.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 53,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Isomerate", _br12 || (_br12 = /*#__PURE__*/React.createElement("br", null))))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 27,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Isomerate&lt;br&gt;")))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 112,
    width: 70,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(571.5,114.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 56,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Reformate", _br13 || (_br13 = /*#__PURE__*/React.createElement("br", null))))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Reformate&lt;br&gt;")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(513.5,187.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 71,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Hydrocracker"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Hydrocracker")))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 737,
    y: 209.5,
    width: 60,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(738.5,212.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 42,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Alkylate", _br14 || (_br14 = /*#__PURE__*/React.createElement("br", null))))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 21,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Alkylate&lt;br&gt;")))), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 270,
    width: 85,
    height: 35,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 717 287 L 911 287 L 911 229.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 911 224.12 L 914.5 231.12 L 911 229.37 L 907.5 231.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(636.5,281.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 67,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Hydrotreater"))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Hydrotreater")))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 543,
    y: 267,
    width: 60,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544.5,269.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 45,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Naphtha", _br15 || (_br15 = /*#__PURE__*/React.createElement("br", null))))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 23,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Naphtha&lt;br&gt;")))), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 777,
    y: 264.5,
    width: 90,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(778.5,267.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 75,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "FCC Gasoline", _br16 || (_br16 = /*#__PURE__*/React.createElement("br", null))))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "FCC Gasoline&lt;br&gt;")))), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 507,
    y: 439.5,
    width: 100,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(508.5,442.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 81,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Coker Naphtha"))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Coker Naphtha")))), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 168,
    width: 140,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(668.5,170.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 125,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Hydrocracked Gasoline", _br17 || (_br17 = /*#__PURE__*/React.createElement("br", null))))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 63,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Hydrocracked Gasoline&lt;br&gt;")))), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 420,
    width: 60,
    height: 40,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(363.5,422.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 43,
    height: 40,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Heavy", _br18 || (_br18 = /*#__PURE__*/React.createElement("br", null)), "Vacuum", _br19 || (_br19 = /*#__PURE__*/React.createElement("br", null)), "Gasoil", _br20 || (_br20 = /*#__PURE__*/React.createElement("br", null))))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 26,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(638.5,219.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 51,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Alkylation"))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Alkylation")))), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 211,
    width: 70,
    height: 20,
    fill: "#f19c99",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(553.5,213.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 53,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Petchems", _br21 || (_br21 = /*#__PURE__*/React.createElement("br", null))))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 27,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Petchems&lt;br&gt;")))), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 630,
    width: 60,
    height: 20,
    fill: "#b9e0a5",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(461.5,632.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 44,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Bitumen"))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Bitumen")))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 327 570 L 327 640 L 453.63 640",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 458.88 640 L 451.88 643.5 L 453.63 640 L 451.88 636.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 367 18 L 387 18 L 380 18 L 393.63 18",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 398.88 18 L 391.88 21.5 L 393.63 18 L 391.88 14.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 0,
    width: 95,
    height: 35,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 497 17.5 L 553.63 17.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 558.88 17.5 L 551.88 21 L 553.63 17.5 L 551.88 14 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 0,
    width: 97,
    height: 35,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 237 70 L 237 20 L 263.63 20",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 268.88 20 L 261.88 23.5 L 263.63 20 L 261.88 16.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 7.5,
    width: 40,
    height: 20,
    fill: "#b9e0a5",
    stroke: "none",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558.5,10.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 24,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "LPG"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "LPG")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273.5,10.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 85,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Gas Processing"))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Gas Processing")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.5,10.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 81,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Merox Treaters"))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Merox Treaters")))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M 268 170 L 268 161 L 866 161 L 866 193.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 866 198.88 L 862.5 191.88 L 866 193.63 L 869.5 191.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefinery);
export default __webpack_public_path__ + "static/media/refinery.8069259b54805822ceac1f2d285ab294.svg";
export { ForwardRef as ReactComponent };